import { NgModule } from '@angular/core';
import { ConsentEventBuilder } from './consent-event.builder';

@NgModule({})
export class ConsentEventModule {
  constructor(_consentEventBuilder: ConsentEventBuilder) {}
}
